// extracted by mini-css-extract-plugin
module.exports = {"foodcourt_layout_list":"Home_foodcourt_layout_list__3FPN1","title":"Home_title__W_yJi","line":"Home_line__OgbMF","foodCourtHomeMap":"Home_foodCourtHomeMap__2sVY3"};